const prefixURL = 'dogfood/v1'

export default {
  // WP API MAPPER
  menus: '/wp-api-menus/v2/menus/:menu_id',
  page: prefixURL + '/page/:slug',
  product: prefixURL + '/product/:slug',
  products: prefixURL + '/product/',
  brands: prefixURL + '/brand/',
  categories: prefixURL + '/category/',

  // NODE API MAPPER
  signup: 'v1/public/signup',
  forgotPassword: 'v1/public/reset-password',

  payment_method: 'v1/payment-method',
  payment_method_by_token: 'v1/payment-method/:token',
  payment_token: 'v1/bt-gateway/token',
  profile: 'v1/profile',
  my_pet: 'v1/profile/pet',
  new_order: 'v1/order',
  subscription: 'v1/subscription',
  subscription_by_id: 'v1/subscription/:id'
}
